(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["punchandi-pasek-info"] && !Shopify.designMode) return;
  try {
    
class PunchandiPasek extends HTMLElement{
  connectedCallback(){
    this.items=[...this.querySelectorAll('.pnd-pasek__item')];
    if(this.items.length<2)return;
    this.i=0;
    this.interval=(parseInt(this.style.getPropertyValue('--pnd-interval'))||4)*1000;
    this.querySelector('.pnd-pasek__nav--prev')?.addEventListener('click',()=>this.go(-1));
    this.querySelector('.pnd-pasek__nav--next')?.addEventListener('click',()=>this.go(1));
    this.timer=setInterval(()=>this.go(1),this.interval);
  }
  disconnectedCallback(){clearInterval(this.timer)}
  go(d){this.items[this.i].classList.remove('is-active');this.i=(this.i+d+this.items.length)%this.items.length;this.items[this.i].classList.add('is-active')}
}
customElements.define('punchandi-pasek',PunchandiPasek);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["punchandi-produkt"] && !Shopify.designMode) return;
  try {
    
class PunchandiGaleria extends HTMLElement{
  connectedCallback(){
    this.slides=[...this.querySelectorAll('.pnd-gal__slide')];
    this.dots=[...this.querySelectorAll('.pnd-gal__dot')];
    if(this.slides.length<2)return;
    this.i=0;
    this.dots.forEach(d=>d.addEventListener('click',()=>this.show(parseInt(d.dataset.goto))));
    let x0=null;const stage=this.querySelector('.pnd-gal__stage');
    stage.addEventListener('touchstart',e=>x0=e.touches[0].clientX,{passive:true});
    stage.addEventListener('touchend',e=>{if(x0===null)return;const dx=e.changedTouches[0].clientX-x0;if(Math.abs(dx)>40)this.show((this.i+(dx<0?1:-1)+this.slides.length)%this.slides.length);x0=null;});
  }
  show(n){this.slides[this.i].classList.remove('is-active');this.dots[this.i]?.classList.remove('is-active');this.i=n;this.slides[n].classList.add('is-active');this.dots[n]?.classList.add('is-active')}
}
customElements.define('punchandi-galeria',PunchandiGaleria);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["szelki1-opinie"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var a = e.target.closest('[data-szo-dir]');
  if (a) {
    var t = a.closest('.szo').querySelector('[data-szo-track]');
    t.scrollBy({ left: Number(a.getAttribute('data-szo-dir')) * t.clientWidth * 0.8, behavior: 'smooth' });
    return;
  }
  var z = e.target.closest('[data-szo-zoom]');
  if (z) {
    var o = document.createElement('div');
    o.className = 'szo-lb';
    var im = document.createElement('img');
    im.src = z.getAttribute('data-szo-zoom');
    im.alt = '';
    o.appendChild(im);
    o.addEventListener('click', function () { o.remove(); });
    document.body.appendChild(o);
  }
});

  } catch(e) { console.error(e); }
})();
})();
